export default {
  default: () => import("/tmp/build/d411e185/code/layouts/default.vue").then(m => m.default || m)
}